export default {
    fmotc_typ: '',
    fmotc_mat: '',
    ftyp_offre: '',
    fmotc_cat: '',
    fmotc_cae: '',
    fmotc_caf: '',
    frech_lib: '',
    fgrp_col: '',
    filter_tag: Array(),
    poffset: 0,
    num_page: 0,
    current_filter_tag_remove: Object(),
    fmotc_cat_preselected: '',
    launch_research: false,
    reset_product_list: false,
    remove_tag_filter: false
};